export default __webpack_public_path__ + "media/images/react_icons/forward-30a3dc1f3363e5966fce796c12e77976.svg";